module.exports = __webpack_public_path__ + "2215e07077b1bdc9eef1c8715c38cec7.jpg";